import { useSanityProduct } from 'hooks/product/useSanityProduct';
import { useShopifyProduct } from 'hooks/product/useShopifyProduct';
import type { SupplementPickerProduct } from 'types/cms/blocks/SupplementPicker';

export const useGetProductData = ({
  product,
}: {
  product: SupplementPickerProduct;
}) => {
  const { slug } = product.product;

  const sanityProduct = useSanityProduct(slug, {
    required: true,
  });

  const { data: shopifyProduct, isLoading } = useShopifyProduct(slug);

  const variantIds = product.variants?.length
    ? product.variants?.map((v) => v.gid)
    : null;

  const allVariants = shopifyProduct?.variants || [];
  const allSubscriptions =
    shopifyProduct && 'subscriptions' in shopifyProduct
      ? shopifyProduct.subscriptions
      : [];

  const variants = variantIds
    ? allVariants.filter((v) => variantIds.includes(v.id))
    : allVariants;

  const subscriptions = variantIds
    ? allSubscriptions.filter((s) => variantIds.includes(s.id))
    : allSubscriptions;

  return {
    product,
    sanityProduct,
    shopifyProduct,
    isLoading,
    variants,
    subscriptions,
  };
};
